export default __webpack_public_path__ + "static/media/ClassIcon.000179a6.svg";